"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageExtraction = void 0;
var color_1 = require("../metadata/color");
var explicit_content_1 = require("../metadata/explicit-content");
var face_1 = require("../metadata/face");
var label_1 = require("../metadata/label");
var ImageExtraction = /** @class */ (function () {
    function ImageExtraction(data) {
        if (data.colors && data.colors.length) {
            this.colors = data.colors.map(function (color) { return new color_1.Color(color); });
        }
        if (data.labels && data.labels.length) {
            this.labels = data.labels.map(function (label) { return new label_1.Label(label); });
        }
        if (data.faces && data.faces.length) {
            this.faces = data.faces.map(function (face) { return new face_1.Face(face.height, face.width, face.x, face.y); });
        }
        if (data.explicitContent && data.explicitContent.length) {
            this.explicitContent = data.explicitContent.map(function (explicitContent) {
                return new explicit_content_1.ExplicitContent(explicitContent);
            });
        }
    }
    return ImageExtraction;
}());
exports.ImageExtraction = ImageExtraction;
//# sourceMappingURL=image-extraction-response.js.map